import { 
    disclosureStatus,
    orderStatus, 
    statusOrder 
} from '@helpers/order';
import {
    FORM_STATES
} from '@helpers/constants';


export const formState = (order, form) => {
    if(orderStatus(order) === statusOrder.AWAITING_SIGNATURES) {
        return FORM_STATES.AWAITING_SIGNATURES;
    }
    if(orderStatus(order) === statusOrder.COMPLETE) {
        return FORM_STATES.COMPLETE;
    }

    if(!form.isParentForm){
        let sess = order.disclosure.jotFormDisclosureSessions.toArray().find(x=>{
            return x.formUuid === form.uuid;
        });
    
        if(!sess || !sess._fetched) {
            return FORM_STATES.NEW;
        }
        if(!sess.submissionId) {
            return FORM_STATES.INCOMPLETE;
        }
        if(form.allowEdit || sess.submissionId) {
            return FORM_STATES.EDITABLE;
        }
    }else if(form.isParentForm){
        let formStateResponse = FORM_STATES.NEW;
        let totalSections = form.sections.toArray().length;
        let totalCompleted = 0;
        let totalNew = 0;
        form.sections.toArray().forEach(section =>{
            let sectionState = formState(order, section);
            if(sectionState === FORM_STATES.INCOMPLETE){
                formStateResponse = sectionState;                
            }else
            if(sectionState === FORM_STATES.EDITABLE || sectionState === FORM_STATES.AWAITING_SIGNATURES || sectionState === FORM_STATES.COMPLETE){
                totalCompleted += 1;
            }else
            if(sectionState === FORM_STATES.NEW){
                totalNew += 1;
            }

        });
        return totalSections === totalNew ? FORM_STATES.NEW: totalSections === totalCompleted ? FORM_STATES.EDITABLE : formStateResponse;
    }
}

export const formStatusIcon = (formState) => {
    if ( formState === FORM_STATES.NEW ) {
        return require('@assets/images/new-form-icon.png');
    } else if ( formState ===FORM_STATES.INCOMPLETE ) {
        return require('@assets/images/in-progress-form-icon.png');
    } else if( formState == FORM_STATES.AWAITING_SIGNATURES){
        return require('@assets/images/v3/form-needs-signature.png');
    } else if ( formState == FORM_STATES.COMPLETE || formState == FORM_STATES.EDITABLE ) {
        return require('@assets/images/completed-form-icon.png');
    }
}
export const formStatusText = (formState) => {
    if(formState === FORM_STATES.NEW){
        return 'New';
    } else if(formState === FORM_STATES.INCOMPLETE){
        return 'In Progress';
    } else if(formState === FORM_STATES.AWAITING_SIGNATURES){
        return 'Needs Signature'
    } else if(formState == FORM_STATES.COMPLETE || formState == FORM_STATES.EDITABLE){
        return 'Complete';
    }
}

export const formStatusBadge = (formState) => {
    if( formState === FORM_STATES.NEW){
        return 'status-badge new';
    } else if(formState === FORM_STATES.INCOMPLETE){
        return 'status-badge in-progress';
    } else if(formState === FORM_STATES.AWAITING_SIGNATURES){
        return 'status-badge needs-signature';
    } else if(formState == FORM_STATES.COMPLETE || FORM_STATES.EDITABLE){
        return 'status-badge complete';
    }
}

export const formIsComplete = (currentFormState) => {
    if(currentFormState === FORM_STATES.COMPLETE) {
        return true;
    }
    return false;
}

export const formRequiresSignatures = (currentFormState) => {
    if (currentFormState === FORM_STATES.EDITABLE || currentFormState === FORM_STATES.AWAITING_SIGNATURES) {
        return true;
    } else {
        return false;
    }
}